export default __webpack_public_path__ + "static/O0061-8bc42b98565c8ea54a1c5486fba887fe.png";